// extracted by mini-css-extract-plugin
export default {"pager":"pager-widget__pager--2roil"};
    if(module.hot) {
      // 1776411662660
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  